export enum PlayerStateEnum {
  STOPPED = 'STOPPED',
  PLAYING = 'PLAYING',
  PAUSE = 'PAUSE',
}
